import { styled } from '@mui/material'

const StyledCode = styled('code')({
  position: 'fixed',
  bottom: '2em',
  left: '1em',
  padding: '2px 4px',
  color: '#fff',
  fontSize: 12,
  fontFamily: 'Monaco, Consolas, monospace',
  borderRadius: 2,
  background: 'rgba(0, 0, 0, .4)',
  zIndex: 9999,
})

export default function Version() {
  const { MODE, VITE_BUILD_NUMBER } = import.meta.env

  if (!['beta', 'development', 'alpha'].includes(MODE)) {
    return null
  }

  const version = `${MODE}-${VITE_BUILD_NUMBER}`
  return <StyledCode>version: {version}</StyledCode>
}
